import React from 'react';

import { Separator, Spinner } from 'common/components';
import { Glossary } from 'common/utils/glossary';
import { StateType } from 'common/modules/domain/purchase';
import { ContractPlan } from './ContractPlan';
import { default as ContractPlanListMessage } from '../containers/ContractPlanListMessage';
import { Filter } from 'common/containers';

interface ContractPlanListsProps {
  /** 契約中プランのリスト */
  contractPlans: {
    purchaseId: string;
    imageSrc: string;
    contractPlanId: string;
    contractPlanName: string;
    operationDatetime: string;
    expirationDatetime: string | null;
    expirationGraceDays: number | null;
    contractTaxIncludedPrice: number | null;
    vendorPurchaseId: string;
    validityPeriod: number | null;
    perpetualValidityPeriod: number | null;
    usage: number | null;
    limit: number | null;
    currency: string | null;
    isDemo: boolean;
    isCanceled: boolean;
    state: StateType;
    planLimit: number | null;
    planUsage: number | null;
    lendingQuantity: number | null;
    purchaseQuantity: number | null;
    deviceLimitType: number | null;
    lendingStatus: string | null;
    lendingType: number | null;
    renewalType: string | null;
    onClickDetail: () => void;
    onClickCancel: () => void;
    onClickDevice: () => void;
    onClickCancellationOfUse: () => void;
    onClickLendingUser: () => void;
    onClickActivate: () => void;
  }[];
  /** 初期化処理 */
  initializePage: () => void;
  /** グロッサリ */
  glossary: Glossary;
  /** 言語 */
  language: string;
  /** ログイン済みか否か */
  isLoggedIn: boolean;
  /** 購入履歴取得中か否か */
  isProcessing: boolean;
}

/**
 * プランリストのPresentation Component
 */
export const ContractPlanLists: React.FC<ContractPlanListsProps> = ({
  contractPlans,
  initializePage,
  glossary,
  language,
  isLoggedIn,
  isProcessing
}) => {
  // 初期化処理のイベント
  React.useEffect(() => {
    initializePage();
  }, []);

  // リスト部に表示するComponentをメモライズ
  const listComponent = React.useMemo(() => {
    return contractPlans.map((contractPlan) => (
      <ContractPlan
        {...contractPlan}
        glossary={glossary}
        language={language}
        data-test={contractPlan.vendorPurchaseId}
        key={contractPlan.purchaseId}
      />
    ));
  }, [contractPlans]);

  return (
    <div className="contract" data-test="contractPlanLists">
      <Filter />
      <Separator
        type="separator"
        data-test="contractPlanLists-separator"
        className="contractPlanLists-separator"
      />
      <ContractPlanListMessage />
      {listComponent}
      {!isLoggedIn || isProcessing ? <Spinner /> : null}
    </div>
  );
};
